import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import VueI18n from 'vue-i18n';
import { NavigationGuardNext, Route } from 'vue-router';

export const login: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.login.title') as string;
			},
			isPublic: true,
		},
		beforeEnter(to: Route, from: Route, next: NavigationGuardNext): void {
			if (!CurrentUserStore.isLoggedIn.value) {
				next();
				return;
			}
			next({
				name: Routes.GROUP_MAIN,
				params: to.params,
			});
		},
		path: '/login/groups/:groupId',
		name: Routes.GROUP_LOGIN,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
				redirectPath: route.query.url,
			};
		},
		component: () => import(/* webpackChunkName: "eventLogin" */ '@front-app/views/login/GroupLogin.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.event.login.title') as string;
			},
			isPublic: true,
		},
		beforeEnter(to: Route, from: Route, next: NavigationGuardNext): void {
			if (!CurrentUserStore.isLoggedIn.value) {
				next();
				return;
			}
			next({
				name: Routes.GROUP_EVENT,
				params: to.params,
			});
		},
		path: '/login/groups/:groupId/events/:eventId',
		name: Routes.GROUP_EVENT_LOGIN,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
				eventId: route.params.eventId,
			};
		},
		component: () => import(/* webpackChunkName: "eventLogin" */ '@front-app/views/login/EventLogin.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('event.login.title') as string;
			},
			isPublic: true,
		},
		beforeEnter(to: Route, from: Route, next: NavigationGuardNext): void {
			if (!CurrentUserStore.isLoggedIn.value) {
				next();
				return;
			}
			next({
				name: Routes.EVENT,
				params: to.params,
			});
		},
		path: '/login/events/:eventId',
		name: Routes.EVENT_LOGIN,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				eventId: route.params.eventId,
			};
		},
		component: () => import(/* webpackChunkName: "eventLogin" */ '@front-app/views/login/EventLogin.vue'),
	},
];
